
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"13.86","height":"23.052"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Internet-Networks-Servers / Bluetooth / bluetooth"}},[_c('g',{attrs:{"data-name":"Group 68"}},[_c('path',{attrs:{"data-name":"Shape 490","d":"M.731 5.028l12.317 11.323a.948.948 0 01.025 1.381l-4.632 4.592c-.391.387-.71.254-.71-.3v-21c0-.55.319-.683.71-.3l4.632 4.592a.948.948 0 01-.026 1.38L.706 18.028","fill":"none","stroke":"#000","stroke-linecap":"round","stroke-linejoin":"round"}})])])])
          )
        }
      }
    